import classNames from 'classnames';
import { FC } from 'react';

import { Breakpoint } from '../../utils/breakpoint';

import { useBreakpoint } from '../../hooks/useBreakpoint';

export interface ITariffCardLabelProps {
  title: string;
  className?: string;
}

export const TariffCardInfoLabel: FC<ITariffCardLabelProps> = ({ className, title }) => {
  const breakpoint = useBreakpoint();

  return (
    <div
      className={classNames(
        'flex items-center justify-center px-4 py-2 bg-danger-surface text-primary rounded-chip',
        {
          'text-ui-xs-strong': breakpoint < Breakpoint.Lg,
          'text-body-l-strong': breakpoint >= Breakpoint.Lg,
        },
        className,
      )}
      style={{
        minHeight: '32px',
        maxWidth: breakpoint >= Breakpoint.Lg ? '4gi50px' : '200px',
        margin: '0 auto',
      }}
    >
      <p className="text-center">{title}</p>
    </div>
  );
};
